<div class="container my-4">
  <div *ngIf="currentStep === 1 && showCongratulationMessage">
    <div class="text-center">
      <div class="d-flex justify-content-center">
        <img   [src]='environment1 + "assets/images/success.svg"' alt="success-img">
      </div>
      <div class="cotent" style="justify-content: center; display: grid;">
        <h3>Congratulations!</h3>
        <p class="colordata">You have successfully redeemed {{storedReward.product}} voucher worth {{ worthstoredValue }}.</p>
        <p class="colords">Please check your SMS/Email to get the details of your purchese.</p>
      </div>
    </div>
    <div class="row d-flex button-center">
      <div class="col-12 col-lg-6 mb-2">
        <button type="button" class="btn btn-outline-primary btn-grad-outline-primary btn-brand btn-lg w-100"
          (click)="openRewardCenter()" aria-label="Close">
          Explore Reward Center
        </button>
      </div>
      <div class="col-12 col-lg-6">
        <button type="button" class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100" (click)="nextStep()">
          View My Statements
        </button>
      </div>
    </div>

  </div>

  <div *ngIf="currentStep === 2 && showCongratulationMessage">
    <div class="text-center">
      <div class="d-flex justify-content-center">
        <img  [src]='environment1 + "assets/images/pending.png"' alt="success-img">
      </div>
      <div class="cotent" style="justify-content: center; display: grid;">
        <h1>Processing</h1>
        <p class="colordata">Your {{storedReward.product}} voucher redemption is being processed.</p>
        <p class="colords">Please check your SMS/Email for further updates once the process is complete.</p>
      </div>
    </div>
    <div class="row d-flex button-center">
      <div class="col-12 col-lg-6 mb-2">
        <button type="button" class="btn btn-outline-primary btn-grad-outline-primary btn-brand btn-lg w-100"
          (click)="openRewardCenter()" aria-label="Close">
          Explore Reward Center
        </button>
      </div>
      <div class="col-12 col-lg-6">
        <button type="button" class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100" (click)="nextStep()">
          View My Statements
        </button>
      </div>
    </div>

  </div>

  <div *ngIf="currentStep === 3 && showCongratulationMessage">
    <div class="text-center">
      <div class="d-flex justify-content-center">
        <img src="https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/images/new-images/error.svg" alt="success-img">
      </div>
      <div class="cotent" style="justify-content: center; display: grid;">
        <h1>Cancelled</h1>
        <p class="colordata">Your {{storedReward.product}} voucher redemption has been cancelled.</p>
        <p class="colords">Please contact support for more details or retry the redemption process.</p>
      </div>
    </div>
    <div class="row d-flex button-center">
      <div class="col-12 col-lg-6 mb-2">
        <button type="button" class="btn btn-outline-primary btn-grad-outline-primary btn-brand btn-lg w-100"
          (click)="openRewardCenter()" aria-label="Close">
          Explore Reward Center
        </button>
      </div>
      <div class="col-12 col-lg-6">
        <button type="button" class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100" (click)="nextStep()">
          View My Statements
        </button>
      </div>
    </div>

  </div>


  <div *ngIf="currentStep === 4">
    <div class="statements-section">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h2> <img *ngIf="isMobile == true" (click)="mobileBack()"  [src]='environment1 + "assets/images/arrow-left.png"'
          class="img-fluid me-2" loading="lazy" style="height: 23px;" /> My Statements</h2>
          <!-- <div class="col-xs-12 d-none d-md-block" style="margin-top: -8px; cursor: pointer; font-size: 16px; line-height: 21.6px; font-weight: 700;">
            <a (click)="openRewardCenter()" class="text-primary">Explore Reward Center ></a>
          </div> -->
        <!-- <a *ngIf="isMobile == false" (click)="openRewardCenter()" class="text-primary" style="margin-top: -8px;">Explore Reward Center ></a> -->
      </div>

      <!-- Statement Items -->

      <div *ngFor="let item of loyalityStatementData | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: totalItemsOffers, id: 'booking' }" class="statement-card mb-3 p-3">
        <div class="row">
          <ng-container *ngIf="item.transaction_type === 'ACC'">
            <div class="col-12 mb-2">
              <strong>{{ item.lead_acc_list?.[0].ppl ?? "-" }}</strong>
            </div>
              <!-- Vc Number -->
            <div class="col-md-3 col-6">
              <p>Vc No</p>
              <span>{{ item.lead_acc_list?.[0].vc ?? "-" }}</span>
            </div>
            <!-- Accuumulated Point -->
            <div class="col-md-3 col-6">
              <p>
                Accumulated
              </p>
              <span>₹{{ item.points ?? "-" }}&nbsp;<svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="green"
                class="bi bi-plus"
              >
                <circle cx="12" cy="12" r="10" fill="#006400" />
                <path
                  d="M12 8a.5.5 0 0 1 .5.5v3.5h3.5a.5.5 0 0 1 0 1h-3.5v3.5a.5.5 0 0 1-1 0v-3.5H8a.5.5 0 0 1 0-1h3.5V8.5A.5.5 0 0 1 12 8z"
                  fill="white"
                />
              </svg></span>
            </div>
            <!--  TotalAccuumulated Point -->
            <div class="col-md-3 col-6">
              <p>Total Accumulated</p>
              <span>₹{{ item.points ?? "-" }}</span>
            </div>
          </ng-container>
  
          <ng-container *ngIf="item.transaction_type === 'RED'">
            <!-- Gift Card Name -->
            <div class="col-12 mb-2">
              <strong>{{ item.product_name ?? "-" }}</strong>
            </div>
            <!-- Quantity -->
            <div class="col-md-3 col-6">
              <p>Qty</p>
              <span>{{ item.quantity ?? "-" }}</span>
            </div>
            <!-- Redeemed Amount -->
            <div class="col-md-3 col-6">
              <p>Redeemed</p>
              <span>₹{{ item.points ?? "-" }}<svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                class="bi bi-minus"
              >
                <!-- Circle Background -->
                <circle cx="12" cy="12" r="10" fill="orange" />
                <!-- Minus Icon -->
                <path
                  d="M8 12a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5z"
                  fill="white"
                />
              </svg>
              </span>
            </div>
            <!-- Remaining Amount -->
            <div class="col-md-3 col-6">
              <p>Total Redeemed</p>
              <span>₹{{ item.total_points ?? "-" }}</span>
            </div>
          </ng-container>
          
          <!-- Payment Status -->
          <div class="col-md-3 col-6 text-end">
            <p>Payment Status</p>
            <p style="color: #1F1F1F;" *ngIf="item.status === 'PROCESSING' || item.status === 'INPROCESS'"><span><img [src]="environment1 + 'assets/images/clock.webp'"
              alt="confirmed-clock-img" class="imgimg"></span>Processing</p>
            <p style="color: #1F1F1F;" *ngIf="item.status === 'COMPLETE'"><span><img [src]="environment1 + 'assets/images/tick-circle.webp'"
              alt="confirmed-clock-img" class="imgimg"></span>Confirmed</p>
              <p style="color: #1F1F1F;" *ngIf="item.status === 'PENDING'"><span><img [src]="environment1 + 'assets/images/clock.webp'"
                alt="confirmed-clock-img" class="imgimg"></span>Pending</p>
              <p style="color: #1F1F1F;" *ngIf="item.status === 'CANCELED' || item.status === 'CANCELLED'"><span><img [src]="environment1 + 'assets/images/clock.webp'"
                alt="confirmed-clock-img" class="imgimg"></span>Cancelled</p>
                <p style="color: #1F1F1F;" *ngIf="item.status === 'CANCELLED_OR_LOST'"><span><img [src]="environment1 + 'assets/images/clock.webp'"
                  alt="confirmed-clock-img" class="imgimg"></span>Cancelled or Lost</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12  paging-custom " *ngIf="loyalityStatementData?.length > 0">
      <pagination-controls class="col-xs-12" *ngIf="totalItemsOffers > itemsPerPage"
        (pageChange)="pageChangeLoyalityStatement($event)" previousLabel=" " nextLabel=" " id='booking'
        [maxSize]="maximumSize"></pagination-controls>
    </div>
    <div class="col-xs-12 d-md-none" style="margin: 12px 23px 10px 108px" *ngIf="isMobile == true">
      <a (click)="openRewardCenter()" class="text-primary">Explore Reward Center ></a>
    </div>
  </div>
</div>